export const ZegoInvitationType = {
  voiceCall: 0,
  videoCall: 1,
};
